module.exports = __webpack_public_path__ + "images/locator/icon-juul-logo-white-fdeec0af.svg";